export var Constants;
(function (Constants) {
    Constants[Constants["IMAGE_EXPIRATION_TIME"] = 10800000] = "IMAGE_EXPIRATION_TIME";
    Constants["DEV_NAMESPACE"] = "dev";
    Constants["HLG_NAMESPACE"] = "hlg";
    Constants["PLAYGROUND_HOST"] = "localhost:9009";
    Constants["PLATFORMS_HOST"] = "localhost:3003";
    Constants["STORAGE_URL_DEV"] = "https://hyperaadmindev.blob.core.windows.net";
    Constants["STORAGE_URL_HLG"] = "https://hyperaadminhlg.blob.core.windows.net";
    Constants["STORAGE_URL_PROD"] = "https://hyperaadminprod.blob.core.windows.net";
    Constants["FALLBACK_IMAGE"] = "https://hyperaadminhlg.blob.core.windows.net/partner-images/placeholder_product_image_not_found.png";
})(Constants || (Constants = {}));
//# sourceMappingURL=configs.js.map